import NewUserTable from "./NewUserTable";

export default function PatientDashboardPage() {
  return (
    <div>
      <NewUserTable />
    </div>
  );
}
